<template>
  <div class="app-container">
    <div class="client_img">
      <img :src="require(`@/assets/img/${theme[2].imgUrl}/Syg_icon_sdfsdfsdf.png`)">
    </div>
    <a v-if="init.service_info.live_url" :href="init.service_info.live_url" class="btn_plain" :style="`color: ${themeConfig.dark}; border-color: ${themeConfig.dark}`">点击联系客服</a>
    <div class="footer_links" v-if="init.service_info.qq" :style="isHorizontal ? 'left: 20%;' : null">QQ客服：<a :href='qq_link'>{{init.service_info.qq}}</a></div>
    <div class="footer_links" v-if="init.service_info.phone" :style="isHorizontal ? 'left: 20%;' : null">客服热线：<a :href='phone_link'>{{init.service_info.phone}}</a></div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  name: 'Customer',
  data () {
    return {
      qq_link: '',
      phone_link: ''
    }
  },
  mounted () {
    // if (this.init.identity === 2366 || this.init.identity === 1668 || this.init.identity === 2482) {
    this.qq_link = `mqqapi://card/show_pslcard?src_type=internal&version=1&uin=${this.init.service_info.qq}&card_type=person&source=qrcode?alipays://alipayclient/`
    this.phone_link = `tel:${this.init.service_info.phone}?alipays://alipayclient/`
    // } else {
    //   this.qq_link = `mqqapi://card/show_pslcard?src_type=internal&version=1&uin=${this.init.service_info.qq}&card_type=person&source=qrcode`
    //   this.phone_link = `tel:${this.init.service_info.phone}`
    // }
  },
  computed: {
    ...mapGetters([
      'themeConfig',
      'isHorizontal',
      'theme',
      'init'
    ])
  }
}
</script>

<style lang="less" scoped>
.app-container {
  overflow: hidden;
  position: relative;
}
.client_img {
  margin: .6rem auto .5rem;
  width: 2.4rem;
  img {
    display: block;
    width: 100%;
  }
}
.btn_plain {
  border: 1.45px solid;
  border-radius: .1rem;
  font-size: .24rem;
  line-height: .7rem;
  width: 2.3rem;
  margin: 0.3rem auto;
  text-align: center;
  display: block;
}
.footer_links {
  margin-top: .2rem;
  color: #46aff1;
  text-align: center;
  font-size: .18rem;
  a {
    color: #46aff1;
  }
}
.b120 {
  bottom: 1.2rem;
}
</style>
